import { createFileRoute } from "@tanstack/react-router";
import AdminBannersContent from "@/pages/admin/AdminBanners";
import { z } from "zod";

export const Route = createFileRoute("/admin/marketing/banners")({
  validateSearch: z.object({ criar: z.literal("campanha").optional() }),
  component: BannersRoute,
});

function BannersRoute() {
  const search = Route.useSearch();
  return <AdminBannersContent createOnMount={search.criar === "campanha"} />;
}
